import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-transactions-filter',
  templateUrl: './transactions-filter.component.html',
  styleUrls: ['./transactions-filter.component.scss']
})
export class TransactionsFilterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
